import { Common } from './common.service';

declare var TableExport: any;

const init = async () => {
    Common.addScript('https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js');
    Common.addScript('https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js');
    Common.addScript('https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js');
    Common.addScript('https://cdnjs.cloudflare.com/ajax/libs/TableExport/5.2.0/js/tableexport.min.js');

    console.log('Table Exporter initialized');
    return true;
}

export const TableExporter = {
    export: async (tableID: string, type: string = 'txt') => {
        const result = await init();
        if (!result) {
            console.error('Table Exporter initialization failed');
            return;
        }
        if (!tableID) {
            console.error('Table ID is required for export');
            return;
        }

        const ele: any = document.getElementById(tableID);
        if (ele) {
            console.log('Table Element: ', tableID, ele);
            TableExport(ele);
        } else {
            console.error(`Table with ID ${tableID} not found`);
        }
    }

}